import { UserManagerSettings } from "oidc-client-ts";

export const AuthConfig: UserManagerSettings = {
    authority: "https://localhost:7157",
    client_id: "userManager",
    client_secret: '901564A5-E7FE-42CB-B10D-61EF6A8F3654',
    redirect_uri: "https://localhost:44432",
    response_type: "code",
    scope: "openid profile roles",
    post_logout_redirect_uri: "https://localhost:44432/logout",
    response_mode:"query"
  };